import { render, staticRenderFns } from "./EmergencyStop.vue?vue&type=template&id=13839012&scoped=true"
import script from "./EmergencyStop.vue?vue&type=script&lang=js"
export * from "./EmergencyStop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13839012",
  null
  
)

export default component.exports